import type { StoreApi } from "zustand";

import type { ProjectDraft, VideoEditorState } from "../types";
import { EMPTY_DRAFT } from "../utils";
import { normalizeCustomCaptionStyle, normalizeOverlays } from "../../types";

type Set = StoreApi<VideoEditorState>["setState"];

export type DraftActions = Pick<
  VideoEditorState,
  "setDraft" | "discardDraft"
>;

export function createDraftActions(set: Set): DraftActions {
  return {
    setDraft: (projectId, patch) => {
      set((state) => {
        const existing = state.drafts[projectId] ?? EMPTY_DRAFT;
        const normalizedPatch: Partial<ProjectDraft> = {
          ...patch,
          ...(patch.draftCustomStyle !== undefined
            ? {
                draftCustomStyle: normalizeCustomCaptionStyle(
                  patch.draftCustomStyle,
                ),
              }
            : {}),
          ...(patch.draftOverlays !== undefined
            ? {
                draftOverlays: patch.draftOverlays
                  ? normalizeOverlays(patch.draftOverlays)
                  : patch.draftOverlays,
              }
            : {}),
        };
        const next: ProjectDraft = {
          ...existing,
          ...normalizedPatch,
          lastEditedAt: Date.now(),
        };
        return {
          ...state,
          drafts: { ...state.drafts, [projectId]: next },
        };
      });
    },
    discardDraft: (projectId) => {
      set((state) => ({
        ...state,
        drafts: { ...state.drafts, [projectId]: { ...EMPTY_DRAFT } },
      }));
    },
  };
}
